import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations'
import { RequirementsGetStarted, RequirementsOverview } from 'partner360/features/keyInitiatives'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../../configs/translations'
import { selectCockpitOffering } from '../../../model/selectors'

import { PartnerRequirements } from './partnerRequirements'

import styles from './CockpitInitiativesRequirements.module.scss'

export const CockpitInitiativesRequirements = () => {
  const offering = useSelector(selectCockpitOffering)
  const isOverallOffering = offering === ProgramTypes.Overall

  if (!isOverallOffering) return <PartnerRequirements />

  return (
    <div className={styles.root}>
      <RequirementsOverview />
      <RequirementsGetStarted
        cards={[]}
        onAction={() => undefined}
        placeholder={
          <Translation text={FINANCIAL_COCKPIT_TRANSLATION_KEYS.keyInitiatives.selectOffering} />
        }
      />
    </div>
  )
}
